export class MockJSONIDService {
      public CATMockBreadcrumb = {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [{
      "@type": "ListItem", 
      "position": 1, 
      "name": "iQuanta",
      "item": "https://www.iquanta.in/"  
    },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "Free CAT Mock Tests",
      "item": "https://www.iquanta.in/cat-mock-test"  
    }]
  }
 
  public CATMockProduct ={
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "Free CAT Mock Tests",
    "image": [
      "https://www.iquanta.in/cat-mock-test"
     ],
    "brand": {
      "@type": "Brand",
      "name": "iQuanta"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "ratingCount": "52276"
    },
    "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "0.00",
      "highPrice": "5000",
      "priceCurrency": "INR"
    }
  }

 public CATMockFaq ={
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "How to appear for CAT VARC mock tests?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Candidates can appear for the CAT VARC mock tests on the website of iQuanta. The VARC section consists of 24 questions based on last years pattern. iQuanta offers one of the best VARC mock tests."
      }
    },{
      "@type": "Question",
      "name": "Is it possible to clear CAT by just giving CAT mock exam?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CAT mock exams will allow the candidates to check their preparation level and improve their strategies to appear for the test. However, not only giving CAT mocks is enough, analysing them is also important."
      }
    },{
      "@type": "Question",
      "name": "What are the benefits of giving CAT online mock tests?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CAT online mock tests help the candidates to analyze their performance level, understand the exam pattern, time management, stress management, identify their strengths and weaknesses."
      }
    },{
      "@type": "Question",
      "name": "How many CAT online mock tests should be practiced in order to score well in the CAT exam?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The candidates should practice enough mock tests before applying for the final CAT exam. However, the minimum number of mock tests that a student must practice before the final exam is 30 or 40."
      }
    },{
      "@type": "Question",
      "name": "How many mocks does iQuanta provide in their CAT test series?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "iQuanta offers one of the best CAT test series with 20 iCAT mocks, 15 free mini mocks, 45 sectional mocks, 15 unproctored mocks. The students will also get to practice previous year papers, topic wise previous year question papers."
      } 
    }]
  }
}